import { render, staticRenderFns } from "./hiPay.vue?vue&type=template&id=6f5df930&scoped=true"
import script from "./hiPay.vue?vue&type=script&lang=js"
export * from "./hiPay.vue?vue&type=script&lang=js"
import style0 from "./hiPay.vue?vue&type=style&index=0&id=6f5df930&prod&lang=scss&scoped=true"
import style1 from "./hiPay.vue?vue&type=style&index=1&id=6f5df930&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5df930",
  null
  
)

export default component.exports